export default __webpack_public_path__ + "static/related-do-5b1fda419667a8a4c2c9046b9e950cd1.png";